import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { Router } from '@angular/router';
import {
  SearchAutocompleteComponent,
  SearchResult,
} from '../../components/search-autocomplete/search-autocomplete.component';
import { NotificationInboxComponent } from '../../components/notification-inbox/notification-inbox.component';
import { DialogService } from '../../shared/services/dialog/dialog.service';
import { NavigationService } from '../../shared/services/navigation/navigation.service';

@Component({
  selector: 'app-projects-header',
  templateUrl: './projects-header.component.html',
  styleUrls: ['./projects-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    SearchAutocompleteComponent,
    NotificationInboxComponent,
  ],
})
export class ProjectsHeaderComponent {
  private router = inject(Router);
  private dialogService = inject(DialogService);
  readonly #navigation = inject(NavigationService);

  onResultSelected(result: SearchResult): void {
    void this.#navigation.openSearchResult(result);
  }

  onImport(): void {
    this.dialogService
      .componentsImportProjectDialog()
      .subscribe((result: any) => {
        if (result) {
          console.log('Project imported:', result);
          // Navigate to the imported project
          if (result.projectId) {
            this.router.navigate(['/project', result.projectId]);
          }
        }
      });
  }

  onNewProject(): void {
    this.dialogService.projectCreateDialog().subscribe();
  }
}
